const { default: axiosIns } = require('@/libs/axios')

const DashboardService = {
  // GET - DashboardApiController
  async getDashboard() {
    return axiosIns.get('admin/dashboard').then(response => response.data)
  },
  // POST - DashboardApiController
  async getPropertyStats(filter) {
    return axiosIns.post('admin/dashboard/property', filter).then(response => response.data)
  },
  async getStats(filter) {
    return axiosIns.post('admin/dashboard/chart', filter).then(response => response.data)
  },
}

export default DashboardService
